var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentWalletTab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(3 4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.99998 2.5L0.99998 1.5C0.99998 0.947715 1.4477 0.5 1.99998 0.5L8.99998 0.5C9.55226 0.5 9.99998 0.947715 9.99998 1.5L9.99998 7C9.99998 7.55228 9.55226 8 8.99998 8L7.29989 8",
    stroke: "currentColor",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 1.49999C7.55228 1.49999 8 1.94771 8 2.49999V7.49999C8 8.05228 7.55228 8.49999 7 8.49999H1C0.447715 8.49999 2.41598e-08 8.05228 0 7.49999V2.49999C0 1.94771 0.447715 1.49999 1 1.49999H7ZM6 3.99999C5.72386 3.99999 5.5 4.22385 5.5 4.49999C5.5 4.77614 5.72386 4.99999 6 4.99999C6.27614 4.99999 6.5 4.77614 6.5 4.49999C6.5 4.22385 6.27614 3.99999 6 3.99999Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentWalletTab);
export default __webpack_public_path__ + "static/media/payment-wallet-tab.b4a60b9c2395d9dd164740a44c5d1cd6.svg";
export { ForwardRef as ReactComponent };